<div class="w-100 h-100 h-fit-content" fxLayout="column" fxLayoutAlign="start stretch">
    <div fxLayout="column" fxLayoutAlign="start stretch" class="bc-mono-white radius-16 p-24 mt-24"
         [class.overflow-y-scroll]="isInquiryPanelOpened">
        @if (!isInquiryPanelOpened && !incident.isDeleted) {
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div class="t2-semi-bold">{{ 'i18n_af_labelIncidentCreateInquiry' | translate }}</div>
                <ui-kit-button type="secondary"
                               [label]="'i18n_af_buttonMakeInquiry' | translate"
                               (clickListener)="isInquiryPanelOpened = true"/>
            </div>
        }

        @if (isInquiryPanelOpened) {
            <form
                [formGroup]="form"
                fxLayout="column"
                fxLayoutAlign="start start"
                class="h-fit-content w-100"
                (submit)="createInquiry()">
                <div class="t2-semi-bold" fxFlexAlign="center">{{ 'i18n_af_labelInquiryFormTitle' | translate }}</div>
                <af-dictionary-selector dictionaryName="bin"
                                        class="min-max-w-400 mt-24"
                                        [control]="form.controls.organization"
                                        [filterDictionaryBy]="filterDictionaryBy"
                                        [excludeFromDictionary]="[authHolderService.organizationBin]"
                                        (dictionaryLoaded)="onOrganizationsLoaded($event)"
                                        label="i18n_af_labelOrganizations"
                                        placeholder="i18n_af_placeholderOrganizations"/>
                <div class="t5 c-primary-gray-600 mt-24">{{ 'i18n_af_labelInquiryDetails' | translate }} *</div>
                <mat-form-field class="mt-4 w-100">
          <textarea matInput
                    #descriptionArea
                    maxlength="{{DESCRIPTION_MAX_LENGTH}}"
                    class="resize-none pt-12 pb-12"
                    formControlName="description"
                    [placeholder]="'i18n_af_placeholderIncidentInquiryDescription' | translate"></textarea>
                    <mat-hint align="start" class="t5 c-primary-gray-600">{{ descriptionArea.value.length }}
                        / {{ DESCRIPTION_MAX_LENGTH }}
                    </mat-hint>
                </mat-form-field>
                @if (form.controls.files) {
                    <af-files
                        class="w-100 mt-40"
                        [excludeItemsWithCode1]="true"
                        [form]="form.controls.files"
                        [bucket]="BucketName.INQUIRY_FILES"
                    />
                }
                <div fxLayout="row" fxLayoutAlign="end center" class="mt-24 w-100">
                    <ui-kit-button color="accent"
                                   buttonType="button"
                                   type="text"
                                   (clickListener)="isInquiryPanelOpened = false"
                                   [label]="'i18n_af_buttonCancel' | translate"/>
                    <ui-kit-button spinnerId="submit"
                                   class="ml-24"
                                   [disabled]="form.invalid"
                                   [label]="'i18n_af_buttonSendInquiry' | translate"/>
                </div>
            </form>
        }
    </div>
    <ui-kit-empty-state [items]="inquiriesResponseViewModels"
                        backgroundColor="light"
                        class="mt-24"
                        [isSmall]="isInquiryPanelOpened"
                        [title]="'i18n_af_emptyStateTitleInquiriesNotCreated'"
                        subtitle="i18n_af_emptyStateSubtitleInquiriesNotCreated"
                        icon="ic_empty_state_document"/>
    @if (inquiriesResponseViewModels.length) {
        <div fxLayout="column" fxLayoutAlign="start stretch"
             class="bc-mono-white radius-16 p-24 w-100 mt-24 h-fit-content">
            @for (inquiryByDate of inquiriesResponseViewModels; track inquiryByDate) {
                <div fxLayout="column"
                     fxLayoutAlign="start start" class="w-100">
                    <div class="w-100 mt-24" fxLayout="row" fxLayoutAlign="start center">
                        <div class="t2 c-primary-gray-600">
                            {{ inquiryByDate.isToday ? ('i18n_af_labelToday' | translate) : (inquiryByDate.createdDate | date : 'dd.MM.yyyy') }}
                        </div>
                        <div class="divider w-100 ml-8" fxFlex></div>
                        @if (inquiryByDate.hasUnreadInquiries) {
                            <div class="ml-8 new-message h-fit-content" fxLayout="row"
                                 fxLayoutAlign="start center">
                                <ui-kit-svg class="i-16" name="ic_message"/>
                                <div class="ml-4">{{ 'i18n_af_labelNewNotification' | translate }}</div>
                            </div>
                        }
                    </div>
                    @for (inquiryResponse of inquiryByDate.items; track inquiryResponse; let first = $first) {
                        <div
                            fxLayout="column"
                            fxLayoutAlign="start start"
                            class="w-100"
                            [class.mt-16]="first"
                            fxFlex>
                            @if (inquiryResponse.inquiry) {
                                <af-inquiry-response-panel
                                    [incidentId]="incident.id"
                                    [isInquiry]="true"
                                    [isDeleted]="incident.isDeleted"
                                    [inquiryInfo]="inquiryResponse.inquiry"
                                    [hasResponse]="!!inquiryResponse.response"
                                    (reloadInquiriesListener)="updateInquiries()"
                                    class="w-100"/>
                            }
                            @if (inquiryResponse.response) {
                                <af-inquiry-response-panel
                                    [incidentId]="incident.id"
                                    [inquiryInfo]="inquiryResponse.response"
                                    (reloadInquiriesListener)="updateInquiries()"
                                    class="w-100"/>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    }
</div>
